var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('background: #1797c0 url(' + _vm.commonGradientBody + ') repeat-x'),attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"global-loading"},[_vm._m(0)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spinner"})])
}]

export { render, staticRenderFns }